import React from "react";
import PropTypes from "prop-types";

const BreadCrumbs = ({ rutas = [] }: any) => {

  return (
    <ul className="bread-crumbs">
      {rutas.map(({ link }: any) => (
        <li key={link}>{link}</li>
      ))}
    </ul>
  );
};

export default BreadCrumbs;

BreadCrumbs.propTypes = {
  rutas: PropTypes.array,
};
